import React from "react";
import approachImg from "../assets/images/approach.svg";

export default function GeneenApproach() {
  const bulletPoints = [
    "Listen to your body and feed it what it truly wants",
    "Learn and directly experience what “enough” is",
    "Identify the positive and unconscious reasons why you keep the weight on",
    "Turn off the inner critic and treat yourself with exquisite kindness",
    "Change the beliefs that limit your life and the shape of your body",
  ];

  return (
    <section className="px-4 sm:px-[10%] bg-white mb-8 sm:mb-12">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-6 lg:gap-8 py-8 sm:py-12">
        <div className="flex-1 space-y-4 sm:space-y-5">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-century text-left">
            How Geneen Roth’s Approach&nbsp;is&nbsp;Different:
          </h2>
          <p className="text-sm sm:text-base lg:text-lg font-roboto text-left">
            If you are challenged by what you eat, the size of your body or your
            beliefs about your own worth, then the world really is on your
            plate.
          </p>
          <p className="text-sm sm:text-base lg:text-lg font-roboto text-left">
            Unlike diets that focus solely on food, calories, or weight loss,
            Geneen’s method addresses the deeper emotional and spiritual issues
            that fuel compulsive eating. She emphasizes self-compassion,
            mindfulness, and healing from the inside out—treating food as a
            doorway to understanding our beliefs and patterns.
          </p>
          <p className="text-sm sm:text-base lg:text-lg font-roboto text-left">
            Her retreats foster long-term transformation through self-awareness
            rather than restriction, offering practical tools to cultivate peace
            with both body and mind:
          </p>
          <ul className="text-left list-disc list-inside space-y-2 pl-4 text-sm sm:text-base lg:text-[14px] font-roboto">
            {bulletPoints.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </div>
        <div className="flex-1 flex justify-center mt-6 lg:mt-0">
          <img
            src={approachImg}
            alt="Illustration of a mindful journey"
            className="w-full max-w-md lg:max-w-full h-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
}